export const outboundReducer = function (state, action) {
  switch (action.type) {
    case "OUTBOUND_SHIPMENTS_LOADED":
      return {
        ...state,
        outboundShipments: action.payload,
      };
    case "CLEAR_NOTE":
      const newNotes = { ...state.notes };
      delete newNotes[action.payload.id];
      return {
        ...state,
        notes: newNotes,
      };
    case "UPDATE_CURRENT_SHIPMENT": {
      const payload = action.payload;
      const trackCar =
        payload.trackCar !== undefined
          ? payload.trackCar
          : state.currentShipment?.trackCar;
      return {
        ...state,
        currentShipment: { ...payload, trackCar },
      };
    }
    case "UPDATE_SHIPMENT_LOCATION": {
      const { shipmentId, trackId, locationFullName } = action.payload;
      if (state.currentShipment?.id !== shipmentId) return state;
      if (shipmentId == null || trackId == null) return state;
      const currentTrackCar = state.currentShipment?.trackCar || {};
      const nextTrackCar = {
        ...currentTrackCar,
        trackId,
        locationFullName: locationFullName ?? null,
      };

      return {
        ...state,
        currentShipment: {
          ...state.currentShipment,
          trackCar: nextTrackCar,
        },
      };
    }
    case "UPDATE_CURRENT_INVENTORY":
      state.currentShipment.shipmentLineItems.items =
        state.currentShipment.shipmentLineItems.items.map((itm) =>
          itm.id === action.payload.id ? action.payload : itm
        );
      return {
        ...state,
        currentLineItem: { ...action.payload },
        currentShipment: { ...state.currentShipment },
      };
    // NOTE: This case is prepared for future use with onUpdateInventoryItem subscription.
    // Currently not dispatched because the subscription requires authorization that
    // the Crew App doesn't have. When auth is resolved, this can be wired up for
    // real-time InventoryItem location updates without full refetch.
    case "UPDATE_INVENTORY_ITEM": {
      const updated = action.payload;
      if (!updated?.id) return state;

      const updateLineItem = (lineItem) => {
        const items = lineItem?.inventoryItems?.items;
        if (!Array.isArray(items) || items.length === 0) return lineItem;
        const nextItems = items.map((invItem) => {
          if (invItem?.inventoryItem?.id !== updated.id) return invItem;
          const nextInventory =
            updated.inventory || invItem.inventoryItem?.inventory;
          return {
            ...invItem,
            inventoryItem: {
              ...invItem.inventoryItem,
              ...updated,
              inventory: nextInventory,
            },
          };
        });
        return {
          ...lineItem,
          inventoryItems: { ...lineItem.inventoryItems, items: nextItems },
        };
      };

      const nextShipment =
        state.currentShipment?.shipmentLineItems?.items?.length > 0
          ? {
              ...state.currentShipment,
              shipmentLineItems: {
                ...state.currentShipment.shipmentLineItems,
                items: state.currentShipment.shipmentLineItems.items.map(
                  updateLineItem
                ),
              },
            }
          : state.currentShipment;

      const nextInventoryItems = Array.isArray(state.inventoryItems)
        ? state.inventoryItems.map((item) => {
            if (item?.inventoryItem?.id !== updated.id) return item;
            const nextInventory =
              updated.inventory || item.inventoryItem?.inventory;
            return {
              ...item,
              inventoryItem: {
                ...item.inventoryItem,
                ...updated,
                inventory: nextInventory,
              },
            };
          })
        : state.inventoryItems;

      return {
        ...state,
        currentShipment: nextShipment,
        inventoryItems: nextInventoryItems,
      };
    }
    case "SET_CURRENT_SHIPPMENT":
      const nextCurrentLineItem = state.currentLineItem
        ? action.payload.outboundShipment?.shipmentLineItems?.items?.find(
            (item) => item.id === state.currentLineItem.id
          )
        : null;
      const nextLineItemInventoryItem = state.lineItemInventoryItem
        ? action.payload.inventoryItems?.find(
            (item) => item.id === state.lineItemInventoryItem.id
          )
        : null;
      return {
        ...state,
        currentShipment: { ...action.payload.outboundShipment },
        inventoryItems: action.payload.inventoryItems,
        currentLineItem: nextCurrentLineItem
          ? { ...nextCurrentLineItem }
          : null,
        lineItemInventoryItem: nextLineItemInventoryItem
          ? { ...nextLineItemInventoryItem }
          : null,
      };
    case "SET_INBOUND_SHIPMENT":
      return {
        ...state,
        inboundShipment: action.payload,
      };
    case "SET_SHIPPMENT_NOTE":
      const newShipmentNotes = { ...state.notes };
      newShipmentNotes[action.payload.id] = action.payload.value;
      return {
        ...state,
        notes: newShipmentNotes,
      };
    case "SET_CURRENT_SHIPMENT_LINE_ITEM":
      return {
        ...state,
        currentLineItem: { ...action.payload.currentLineItem },
        lineItemInventoryItem: action.payload.lineItemInventoryItem
          ? { ...action.payload.lineItemInventoryItem }
          : undefined,
      };
    case "SET_MODE":
      return {
        ...state,
        mode: action.payload,
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "UPDATE_YARD_IMG":
      return {
        ...state,
        yardSignatureKey: action.payload,
      };
    case "UPDATE_CARRIER_IMG":
      return {
        ...state,
        carrierSignatureKey: action.payload,
      };
    case "CLEAR_INVENTORY":
      return {
        ...state,
        currentInventory: {},
        carrierSignatureKey: "",
        yardSignatureKey: "",
        currentLineItem: null,
        lineItemInventoryItem: null,
        inboundShipment: null,
        isSourceRailcarValidated: false,
        isTargetRailcarValidated: false,
      };
    case "SET_SOURCE_RAILCAR_VALIDATED":
      return {
        ...state,
        isSourceRailcarValidated: action.payload,
      };
    case "SET_TARGET_RAILCAR_VALIDATED":
      return {
        ...state,
        isTargetRailcarValidated: action.payload,
      };
    default:
      break;
  }
  return state;
};
